import React from "react";
import { Moon } from "lucide-react";

export const MOON_PHASE_IMAGE_PATHS = {
  "new moon": "/moon-phases/new-moon.png",
  "waxing crescent": "/moon-phases/waxing-crescent.png",
  "first quarter": "/moon-phases/first-quarter.png",
  "waxing gibbous": "/moon-phases/waxing-gibbous.png",
  "full moon": "/moon-phases/full-moon.png",
  "waning gibbous": "/moon-phases/waning-gibbous.png",
  "last quarter": "/moon-phases/last-quarter.png",
  "third quarter": "/moon-phases/last-quarter.png",
  "waning crescent": "/moon-phases/waning-crescent.png",
};

export function normalizeMoonPhaseKey(phase) {
  return typeof phase === "string"
    ? phase.toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim()
    : "";
}

export function getMoonPhaseImagePath(phase) {
  const key = normalizeMoonPhaseKey(phase);
  if (MOON_PHASE_IMAGE_PATHS[key]) return MOON_PHASE_IMAGE_PATHS[key];
  if (key.includes("new")) return MOON_PHASE_IMAGE_PATHS["new moon"];
  if (key.includes("waxing") && key.includes("crescent")) {
    return MOON_PHASE_IMAGE_PATHS["waxing crescent"];
  }
  if ((key.includes("first") || key.includes("1st")) && key.includes("quarter")) {
    return MOON_PHASE_IMAGE_PATHS["first quarter"];
  }
  if (key.includes("waxing") && key.includes("gibbous")) {
    return MOON_PHASE_IMAGE_PATHS["waxing gibbous"];
  }
  if (key.includes("full")) return MOON_PHASE_IMAGE_PATHS["full moon"];
  if (key.includes("waning") && key.includes("gibbous")) {
    return MOON_PHASE_IMAGE_PATHS["waning gibbous"];
  }
  if (
    (key.includes("last") || key.includes("third") || key.includes("3rd")) &&
    key.includes("quarter")
  ) {
    return MOON_PHASE_IMAGE_PATHS["last quarter"];
  }
  if (key.includes("waning") && key.includes("crescent")) {
    return MOON_PHASE_IMAGE_PATHS["waning crescent"];
  }
  return "";
}

export default function MoonPhaseIcon({ phase, className = "moon-phase-image" }) {
  const imagePath = getMoonPhaseImagePath(phase);
  if (imagePath) {
    return <img src={imagePath} alt="" aria-hidden="true" className={className} />;
  }
  return <Moon aria-hidden="true" className={`${className} moon-phase-fallback-icon`} />;
}
